import { useEffect, useState } from "react";
import { LifeBuoy, ThumbsUp, ThumbsDown } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export const HelpFeedbackAdmin = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/help-feedback").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <Card className="p-5" data-testid="help-feedback-admin">
      <h3 className="font-bold flex items-center gap-2 mb-1"><LifeBuoy className="w-5 h-5 text-primary" />Centro de ayuda: utilidad de respuestas</h3>
      <p className="text-sm text-muted-foreground mb-4">Votos «¿Te sirvió esta respuesta?». Arriba aparecen las preguntas con más «No»: son las que conviene mejorar.</p>
      {rows === null ? null : rows.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="help-feedback-empty">Aún no hay votos.</p>
      ) : (
        <ul className="divide-y max-h-96 overflow-y-auto" data-testid="help-feedback-list">
          {rows.map((r) => {
            const pct = r.total ? Math.round((r.yes / r.total) * 100) : 0;
            return (
              <li key={r.question_id} className="py-3 flex flex-wrap items-center gap-x-4 gap-y-1.5" data-testid={`help-fb-row-${r.question_id}`}>
                <div className="flex-1 min-w-[12rem]">
                  <p className="text-sm font-medium">{r.question}</p>
                  {r.section && <p className="text-xs text-muted-foreground">{r.section}</p>}
                </div>
                <span className="inline-flex items-center gap-1 text-xs text-emerald-600"><ThumbsUp className="w-3.5 h-3.5" />{r.yes}</span>
                <span className="inline-flex items-center gap-1 text-xs text-destructive"><ThumbsDown className="w-3.5 h-3.5" />{r.no}</span>
                <span className={`text-xs font-semibold w-20 text-right ${pct < 50 ? "text-destructive" : "text-muted-foreground"}`}>{pct}% útil</span>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
};
